const IAUUpdateKind = {
  FLEXIBLE: 0,
  IMMEDIATE: 1,
};

class SpInAppUpdates {
  checkNeedsUpdate = async () => ({ shouldUpdate: false });
  startUpdate = async () => { };
  addStatusUpdateListener = () => { };
  removeStatusUpdateListener = () => { };
}

module.exports = SpInAppUpdates;
module.exports.default = SpInAppUpdates;
module.exports.IAUUpdateKind = IAUUpdateKind;
module.exports.SpInAppUpdates = SpInAppUpdates;
